module.exports = __webpack_public_path__ + "img/stop_btn.c78e6f5a.png";